import Store from "../../../../../redux/store";
import { createSelector } from "reselect";

import * as actions from "./flyer-detail.actions";
import { IFlyerDetailState } from "../types/flyer-detail-state/flyer-detail-state.interface";
import { FlyerDetailForm } from "../types/flyer-detail-form/flyer-detail-form.interface";
import { IFlyerState } from "../../../types/flyer-state/flyer-state.interface";
import { getFlyerState } from "../../../store/flyer.store";
import { LOADING_STATES } from "../../../../../features/loading";

export const getFlyerDetailState = createSelector(
  getFlyerState,
  (state: IFlyerState) => state.flyerDetailState || ({} as IFlyerDetailState)
);

export const getErrors = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.errors
);

export const getFormErrors = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.formErrors
);

export const getFlyer = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.flyer
);

export const getEndAt = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.flyer?.endAt ?? ""
);

export const isLoaded = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.loading.status === LOADING_STATES.loaded.status
);

export const isLoading = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.loading.status === LOADING_STATES.loading.status
);

export const isSaving = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.saving
);

export const isPageExportModalOpen = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.isPageExportModalOpen
);

export function save(form: FlyerDetailForm) {
  Store.dispatch(actions.save(form));
}

export function addPage() {
  Store.dispatch(actions.addPage());
}

export function changeName(name: string) {
  Store.dispatch(actions.changeName(name));
}

export function fetchFlyer(id: number | string) {
  Store.dispatch(actions.fetch(Number(id)));
}

export function goToPage(pageId: number) {
  Store.dispatch(actions.goToPage(pageId));
}

export function deletePage(pageId: number) {
  Store.dispatch(actions.deletePage(pageId));
}

export function resetState() {
  Store.dispatch(actions.resetState());
}

export function clearErrors() {
  Store.dispatch(actions.clearError());
}
